import Resource from "./resource";

export class FeaturesConfigurationResource extends Resource {
    IsMultiTenancyEnabled: boolean;
    IsCommunityActionTemplatesEnabled: boolean;
    IsBuiltInRepoSyncEnabled: boolean;
}

export default FeaturesConfigurationResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/featuresConfigurationResource.ts